export default "__VITE_ASSET__C3uQlqou__"